import $ from 'jquery';
import ko from '@tko/build.knockout';
import _ from 'lodash';
import moment from 'moment-timezone';
import UAParser from 'ua-parser-js';

import LoginService from '../../../services/login.service';
import TranslationService from '../../../services/translation.service';
import BrandingService from '../../../services/branding.service';
import templateMarkup from 'raw-loader!./login-widget.html';
import '../../../app/bindings/ko-bindinghandler-htmlSafe';
import DataProvider from "../../../app/data-framework/data-provider";

function LoginWidget(params) {
    var self = this;

    self.rememberUsername = ko.observable('true' === window.localStorage.getItem('rememberUsername'));

    self.dataProvider = DataProvider.getInstance();
    self.route = params.route;
    self.translationService = new TranslationService();
    self.brandingService = BrandingService;
    self.darkMode = document.documentElement.classList.contains('dark');

    var email = '';
    var password = '';

    var route = self.route();

    self.uaParser = new UAParser();
    self.uaBrowser = self.uaParser.getBrowser();
    self.uaOs = self.uaParser.getOS();

    self.autoLogin = ko.observable(true);

    self.isSsoRedirect = route.request_ === 'login/sso';
    self.isOneCloudRedirect = route.request_ === 'login/onecloud';

    // const routeParams = new URLSearchParams(window.location.search);
    // const ocParam = routeParams.get('oc');
    // const prevRouteParams = new URLSearchParams(self.route().prevURL);
    // const prevOcParam = prevRouteParams.get('oc');

    if (route.email && route.password) {
        // self.autoLogin(true);

        email = route.email;
        password = route.password;

        // When passing email/password on URL we can optionally get referral query parameters
        self.getUserTrackingURIParams(_.get(route, '?query'));
    } else if (route.token) {
        // self.autoLogin(true);

        self.token = route.token;
        email = route.username;
        if (route.orgId) {
            email += '/' + route.orgId; 
        }
        self.userId = route.userid;
        self.isSuLogin = route.request_.includes('/su/');
        self.tgtUrl = _.get(route, 'url*', null);
        if (self.tgtUrl.startsWith('/wxpc/#')) {
            self.tgtUrl = self.tgtUrl.substring(7);
        }
        self.isImpersonation = true;
    // } else if ((ocParam || prevOcParam) && window.Config.iframeMode) {
    //     console.log('detected oc login: ' + ocParam);
    //     email = ocParam || prevOcParam;
    //     console.log('oc email = ' + email);
    //     self.autoLogin(true);
    //     self.isOneCloudRedirect = true;
    } else if (window.Config.isInternalAuth) {
        // always try to auto-login
        self.autoLogin(true);
    } else {
        self.autoLogin(false);
    }

    self.email = ko.observable((ko.unwrap(self.autoLogin) && email) ? email : self.rememberUsername() ? window.localStorage.getItem('username') : '');
    self.password = ko.observable((ko.unwrap(self.autoLogin) && password) ? password : '');
    self.errorMessage = ko.observable(window.sessionStorage.getItem('login-error') || '');
    self.showPasswordField = ko.observable(false);
    sessionStorage.removeItem('login-error');
    self.displayErrorMessage = ko.pureComputed(() => { return self.errorMessage() || '&nbsp;'; });
    self.signingIn = ko.observable(false);
    let wxpToken = LoginService.getWxpToken();

    if (ko.unwrap(self.autoLogin) && ! self.isSsoRedirect && ! self.isOneCloudRedirect && !wxpToken) {
        self.login();
    }

    // TODO: shouldn't this be moved to after the rest of the variable settings?
    setTimeout(function () {
        $('#email').focus();
        $('#email').select();
    }, 10);

    self.createAccountUrl = '/#/login/createAccount';
    self.forgotPasswordUrl = '/#/login/forgotPassword';

    self.currentYear = moment().year();
    self.loginFormVisible = ko.pureComputed(function() {
        return window.Config.isInternalAuth && !ko.unwrap(self.autoLogin)
            && !self.isSsoRedirect && !self.isOneCloudRedirect && !wxpToken;
    });

    if ( !window.Config.isInternalAuth && !self.isSuLogin ) {
        LoginService.isLoggedOut = false;
        LoginService.getActiveSession().then(function(user) {
            self.dataProvider.setSessionInfo(user);
            self.goToNextLocation('User');
        },
        function (url) {
            // error handler - not authenticated, url will point to keycloak login
            window.location.replace(url);
        });
    } else if (self.isSsoRedirect) {
        console.log('detected sso redirect');
        LoginService.completeSSOAuth().then(function(user) {
            self.dataProvider.setSessionInfo(user);
            self.goToNextLocation('User');
        });
    } else if (self.isOneCloudRedirect) {
        console.log('detected OneCloud redirect');
        LoginService.completeOneCloudAuth(email).then(function(user) {
            self.dataProvider.setSessionInfo(user);
            self.goToNextLocation('User');
        });
    } else if (wxpToken) {
        console.log('detected WXP token');
        LoginService.completeWxpAuth(wxpToken).then(function(user) {
            console.log('completed wxp token auth');
            self.dataProvider.setSessionInfo(user);
            self.goToNextLocation('User');
        });
    }
}

LoginWidget.prototype = {

    checkUser: function() {
        var self = this;
        self.errorMessage('');
        if (!self.showPasswordField()) { // this is just an extra check in case button types are wrong and this is called by accident
          if (self.email()) {
            $('next').disabled = true;
            LoginService.checkAuthType(self.email()).then(function (result) {
              // console.log('checkUser=' + JSON.stringify(result));
              LoginService.setupAuthMode(result.orgDomain, result.authType);
              if (result.authType === 'onecloud') {
                  if (window.Config.wxpLogin) {
                      self.errorMessage('Please log into <a href="'+window.Config.wxpLogin+'">Workforce Experience</a> directly.');
                  } else {
                      self.errorMessage('Please log into Workforce Experience directly.');
                  }
                // self.saveRemember();
                // LoginService.startOneCloudAuth(self.email()).then(function (user) {
                //   console.log('startOneCloudAuth: user=' + JSON.stringify(user));
                // }, function (url) {
                //   console.log('startOneCloudAuth: url=' + JSON.stringify(url));
                //   // error handler - not authenticated, url will point to onecloud login url
                //   window.location.replace(url);
                // });
              }
              else if (result.authType === 'saml') {
                self.saveRemember();
                LoginService.startSSOAuth().then(function (user) {
                  console.log('startSSOAuth: user=' + JSON.stringify(user));
                }, function (url) {
                  console.log('startSSOAuth: url=' + JSON.stringify(url));
                  // error handler - not authenticated, url will point to SSO login url
                  window.location.replace(url);
                });
              } else {
                // show password field
                self.showPasswordField(true);
                setTimeout(function () {
                  $('next').disabled = false;
                  if (ko.unwrap(self.password) && !ko.unwrap(self.errorMessage)) {
                    self.saveRemember();
                    self.login(true);
                  } else {
                    $('#password').focus();
                    $('#password').select();
                  }
                }, 10);
              }
            }, function () {
              // TODO: handle error
              $('next').disabled = false;
            });
          } else {
            self.errorMessage('Please enter username.');
          }
        }
    },

    saveRemember: function () {
        var self = this;
        window.localStorage.setItem('rememberUsername', self.rememberUsername() ? 'true' : 'false');
        if (self.rememberUsername()) {
          window.localStorage.setItem('username',self.email());
        }
        else {
          window.localStorage.removeItem('username');

        }
    },

    loginWrapper: function () {
        var self = this;
        if (self.showPasswordField()) { // this is just an extra check in case button types are wrong and this is called by accident
            self.saveRemember();
            self.login();
        }
    },

    login: function (autoNext) {
        var self = this;

        if (self.signingIn()) {
            return;
        }

        self.errorMessage('');
        let isAuto = ko.unwrap(self.autoLogin);

        if (isAuto || (self.email() && (self.password() || self.token))) {
            self.signingIn(true);

            var source = self.userId ? 'Engine' : self.token ? 'Apps' : 'User';

            let errorHandler = function (error) {
                let message = error && (error.message || error);

                // if the refresh token login failed there is no reason to try again
                if (message === 'Refresh token login failed') {
                    self.secondtry = true;
                }

                if (isAuto && !self.secondtry) {
                    //try again for phantom/screen capture
                    // self.dataProvider.logActivity2('autologinfailure', source, '', { errorMsg: error.message, email: self.email(), token: self.token, userid: self.userId });
                    self.secondtry = true;
                    if (typeof message !== 'string') {
                        message = 'Login Failure';
                    }
                    console.log(message + '... Trying again');
                    self.errorMessage(message + '... Trying again');
                    self.signingIn(false);

                    self.login();
                } else {
                    self.signingIn(false);
                    // self.dataProvider.logActivity2('loginfailure', source, '', { errorMsg: message, email: self.email(), token: self.token, userid: self.userId });
                    self.autoLogin(false);
                    if (!isAuto && autoNext !== true) {
                        if (typeof message !== 'string') {
                            message = 'Login Failure';
                        }
                        self.errorMessage(message);
                    }
                    if (autoNext === true) {
                        $('#password').focus();
                        $('#password').select();
                    }
                }
            };
            LoginService.init(self.email(), self.password() || self.token, self.isImpersonation).then(function (user) {
                // if (self.isImpersonation && (self.isAdmin() || self.isProfessional() || self.isSU() || self.isSUPro())) {
                //     if (self.isSuLogin) { // this is only reporting that uses su login
                //         self.dataProvider.logAdminActivity(user.orgId, 'impersonation', 'login-widget.js', 'su login impersonating orgId ' + user.orgId + ' user ' + user.userId, {orgId: user.orgId, userId: user.userId});
                //     } else {
                //         self.dataProvider.logAdminActivity(user.orgId, 'impersonation', 'login-widget.js', 'login impersonating orgId ' + user.orgId + ' user ' + user.userId, {orgId: user.orgId, userId: user.userId});
                //     }
                // }
                    self.dataProvider.setSessionInfo(user);
                    self.goToNextLocation(source);
                }, errorHandler)
                .catch((error) => {
                    console.log(error);
                })
                .finally(() => {
                    LoginService.authInProgress = false;
                    self.signingIn(false);
                });
        }
        else {
            self.autoLogin(false);
            if (!isAuto) {
                self.errorMessage('Please enter username and password.');
            }
        }
    },

    hasDeepLink: function() {
        var idx = window.Config.originalUrl.indexOf('/#');
        return idx > -1 && window.Config.originalUrl.length > (idx + 2);
    },

    goToNextLocation: function(source) {
        var self = this;
        var nextLoc = self.dataProvider.getDefaultLocation();

        function logSuccessfulLogin(message, next) {
            self.dataProvider.logActivity2('loginsuccess', source,
                message, {
                    email: self.email(),
                    token: self.token,
                    userId: self.userId,
                    nextLoc: next
                });
            self.dataProvider.logActivity2('useragent', source,
                self.uaBrowser.name + ' ' + self.uaBrowser.major + ' '
                + self.uaOs.name + ' ' + self.uaOs.version,
                self.uaParser.getResult());
        }

        if (self.isSsoRedirect && self.hasDeepLink()) {
            var hashIdx = window.Config.originalUrl.indexOf('/#');
            nextLoc = window.Config.originalUrl.substring(hashIdx);
            logSuccessfulLogin('Redirecting to sso url', nextLoc);

            if (nextLoc.indexOf('logout') < 0) {
              location.replace(nextLoc);
            } else {
              location.hash = '#';
            }
        }  else if (self.isOneCloudRedirect) {
            nextLoc = window.Config.originalUrl;
            logSuccessfulLogin('Redirecting to sso url', nextLoc);

            if (nextLoc.indexOf('logout') < 0) {
                window.location.href = nextLoc;
            } else {
                location.hash = '#';
            }
        } else if (self.tgtUrl && self.tgtUrl !== 'login') {
            nextLoc = '#' + self.tgtUrl;
            logSuccessfulLogin('Redirecting to target url', nextLoc);
            sessionStorage.setItem('tosSkip', 'true'); // giant hack for report screenshots
            location.replace(nextLoc);
        } else if (self.isSuLogin) {
            //login from scheduling engine; redirect to the fastest and simplest page; passing params so this doesn't get saved as last URL
            location.replace('#monitoring/alerts/params/1');
        } else if (self.route().prevURL) {
            nextLoc = '#' + self.route().prevURL;
            logSuccessfulLogin('Redirecting to desired url', nextLoc);
            location.replace(nextLoc);
        } else {
            location.replace(nextLoc);
        }
    },

    getUserTrackingURIParams: function(query) {
        var self = this;
        self.refEmail = _.get(query, 'refEmail');
        self.refTimestamp = _.get(query, 'refTimestamp');
        self.refCompany = _.get(query, 'refCompany');
        self.refPhone = _.get(query, 'refPhone');
        self.refFirstname = _.get(query, 'refFirstname');
        self.refLastname = _.get(query, 'refLastname');
    },

    emailKeyUp: function(data, event) {
        var self = this;
        if (event.keyCode === 13 /* Return/Enter key code*/) { // the form button calls checkUser, but this is extra work
            // self.showPasswordField(true);
            // $('#password').focus();
            // $('#password').select();
        } else if (self.showPasswordField() === true && event.keyCode) {
            self.showPasswordField(false);
            self.password('');
        }
    },

    emailOnPaste: function (/*target, event*/) {
        // var text = event.originalEvent.clipboardData.getData('text/plain');
        // console.log('emailOnPaste: ' + text);
        var self = this;
        self.showPasswordField(false);
        self.password('');
        return true;
    },

    pwdKeyUp: function(data, event) {
        var self = this;
        if (event.keyCode === 13) {
            // self.login(); // no longer need this - the form button takes care of submitting this
        }
    }
};

export default { viewModel: LoginWidget, template: templateMarkup };
